const atualizarControleFrotas = (state, controleFrotas) => {
    state.controleFrotas = controleFrotas;
}

const atualizarControleFrota = (state, controleFrota) => {
    state.controleFrota = controleFrota;
}

export default {
    atualizarControleFrotas,
    atualizarControleFrota
}